module.exports = __webpack_public_path__ + "img/ABB.17b89e4e.png";